import { atom } from "jotai";

import { BookingWizardDataAtom } from "../../stores";

export const GroupSizeSelectorAtom = atom<number>((get) => {
  const bookingWizardData = get(BookingWizardDataAtom);
  const groupSize = bookingWizardData?.groupSize;
  return groupSize ?? 0;
});
